import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { loadProfile } from '@techstyle/react-accounts';
import { getSession } from '@techstyle/redux-core';

import { subscribeVipBoxNotification } from '../../actions/contacts';

import VipBoxButton from './VipBoxButton';

export function mapStateToProps(state, ownProps) {
  return {
    profile: state.customer,
    isVisitor: getSession(state).isVisitor,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onRequestSubscribe: subscribeVipBoxNotification,
      loadProfile,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(VipBoxButton);
